<template>
  <div
    :style="{
      'width': percent + '%',
      'opacity': show ? 1 : 0
    }"
    :class="{
      [$style.bar]: true,
      [$style.success]: canSuccess,
      [$style.failed]: !canSuccess
    }">
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'progress-bar',

  computed: mapState('progress', [
    'percent',
    'canSuccess',
    'show'
  ])
}
</script>

<style lang="scss" module>
  .bar {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 3px;
    width: 0%;
    transition: width 0.2s, opacity 0.4s;
    opacity: 1;
    background-color: hsla(151, 48%, 66%, 1);
    z-index: $z-index--progress-bar;
  }

  .success {
    background-color: hsla(151, 48%, 66%, 1);
  }
  .failed {
    background-color: hsla(5, 66%, 57%, 1);
  }
</style>



// WEBPACK FOOTER //
// src/components/progress_bar.vue